<template>
  <div>
    <AttachmentDialog
      :v-if="!isReadonly && selectedAttachment !== null"
      :show="showAttachmentDialog"
      :attachment="selectedAttachment"
      :close="closeAttachmentPreview"
    />
    <div class="pa-4">
      <FileUploader
        v-if="!isReadonly"
        label="Click to upload an attachment"
        :url="url"
        :fileUploadData="fileUploadData"
        :success="uploadFinished"
        :onFinished="uploadFinished"
        :onBeforeSending="beforeSending"
      />
      <v-progress-linear indeterminate v-if="isBusy"></v-progress-linear>
    </div>

    <v-list lines="three" color="transparent">
      <v-list-subheader>
        <h3>Attachments</h3>
      </v-list-subheader>
      <v-list-subheader v-if="attachments.length === 0">
        This document has no attachments.
      </v-list-subheader>
      <template v-for="(attachment, index) in attachments" :key="attachment.id">
        <v-divider v-if="index > 0" inset></v-divider>

        <v-list-item>
          <template v-slot:prepend>
            <a v-on:click="download(attachment)">
              <v-icon>mdi-download</v-icon>
            </a>
          </template>

          <v-list-item-title>
            <a v-on:click="previewAttachment(attachment)">
              {{ getTitle(attachment) }}
            </a>
          </v-list-item-title>
          <v-list-item-subtitle> {{ getFileSize(attachment) }}</v-list-item-subtitle>
          <template v-slot:append>
            <a v-if="!isReadonly" v-on:click="deleteAttachment(attachment)">
              <v-icon>mdi-delete</v-icon>
            </a>
          </template>
        </v-list-item>
      </template>
    </v-list>
  </div>
</template>

<script>
import downloadService from "@/services/downloadService";
import attachmentService from "@/services/attachmentService";
import FileUploader from "@/components/FileUploader.vue";
import AttachmentDialog from "@/dialogs/AttachmentDialog.vue";
import store from "@/store";
import { mapState } from "vuex";

export default {
  name: "DocumentAttachments",
  props: {
    attachments: Array,
    documentId: Number,
    isReadonly: Boolean,
    onAttachmentsChanged: Function,
  },
  components: { FileUploader, AttachmentDialog },

  data() {
    return {
      selectedView: 0,
      url: `/documents/upload`,
      fileUploadData: { documentId: this.documentId, isAttachment: true },
      selectedAttachment: null,
      showAttachmentDialog: false,
    };
  },

  computed: {
    ...mapState("appStore", ["isBusy"]),
  },

  methods: {
    getTitle(attachment) {
      return attachment.fileName;
    },
    getFileSize(attachment) {
      const bytes = attachment.fileSize;
      if (bytes === 0) return "0 B";
      const k = 1024;
      const sizes = ["B", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    },
    download(attachment) {
      downloadService.download(`/download/attachment/${attachment.id}`, attachment.fileName);
    },
    async deleteAttachment(attachment) {
      if (await this.$root.$confirmDialog.open("Delete", `Delete ${this.getTitle(attachment)} ?`, "Delete")) {
        await attachmentService.deleteAttachment(attachment.id);
        await this.onAttachmentsChanged();
      }
    },
    previewAttachment(attachment) {
      this.selectedAttachment = attachment;
      this.showAttachmentDialog = true;
    },
    closeAttachmentPreview() {
      this.selectedAttachment = null;
      this.showAttachmentDialog = false;
    },
    beforeSending() {
      store.commit("appStore/isBusy", true);
    },
    async uploadFinished() {
      store.commit("appStore/isBusy", false);
      await this.onAttachmentsChanged();
    },
  },
};
</script>
